import { ThemeConfig } from '../types';
import SectionVerticalDivider from '../components/section-vertical-divider';

const colorRushTheme: ThemeConfig = {
    id: 'color-rush',
    name: 'Color Rush',
    backgroundColor: '#000000',
    bothTickersBlack: true,
    tickerPaddingLeft: 13,
    usesColorRush: true,
    textColor: '#ffffff',
    hideGridsWhenPlayingMedia: true,
    gridColor: `rgba(255, 255, 255, .5)`,
    maxMediaWidth: 648,
    gridOffset: undefined,
    gridLineThickness: undefined,
    fullGrid: undefined,
    sectionGrid: SectionVerticalDivider,
    codification: ['heading', 'eyebrow'],
    enableScrim: true,
    showQr: false,
    sceneCount: 3,
    disableMultiLanguage: true,
    footer: {
        showIconDividers: true,
    },
    sequence: {
        headlineSwitchDuration: 6_000,
        mediaDuration: 6_000,
        mediaGap: 1_000,
        playMediaInterval: 12_000,
    },
    leftBorder: {
        marginRight: 10,
        thickness: 0,
    },
    includeLogo: true,
    style: {
        headline: {
            fontSize: 35,
            marginTop: 10,
            lineHeight: 38,
            letterSpacing: '-0.02em',
            fontFamily: 'helvetica-neue-medium',
        },
        eyebrow: {
            fontFamily: 'helvetica-neue',
            fontSize: 14,
            lineHeight: 20,
            fontWeight: 500,
            letterSpacing: '-0.02em',
            // textTransform: "uppercase",
        },
        footer: {
            fontFamily: 'helvetica-neue',
            fontSize: 14,
            lineHeight: 14.4,
            fontWeight: 500,
            letterSpacing: '-0.02em',
            // textTransform: "uppercase",
        },
        qrContent: undefined,
        ticker: {
            fontFamily: 'futura-condensed',
            // fontFamily: 'helvetica-neue',
            // fontWeight: 500,
            fontSize: 28,
            lineHeight: 28,
            textTransform: 'uppercase',
            letterSpacing: '-0.02em',
        },
    },
};

export default colorRushTheme;
